import * as auth from "./auth";
import * as countries from "./countries";
import * as integration from "./integration";
import * as payment from "./payment";
import * as profile from "./profile";
import * as releases from "./releases";
import * as subscription from "./subscription";
import * as yandexAuth from "./yandexAuth";

export const api = {
  auth,
  countries,
  integration,
  payment,
  profile,
  releases,
  subscription,
  yandexAuth,
};
